import React, { useEffect, useState } from 'react';
import request from '../../../../utils/request';
import AssetListItem from './AssetListItem';
import { Typography } from '@mui/material';
import SummaryViewBox from 'src/pages/Rfq/rfqForm/SummaryViewV2/SummaryViewBox';
import { useSelector } from 'react-redux';
import { selectDataListSectionIds } from 'src/features/rfqDataSlice';
import ClauseAndCoverageAfterSI from '../clauseAndCoverageAfterSI';
import SuminsuredListHeaderDetails from 'src/pages/Rfq/rfqViewBoxV2/SumInsuredItems/SuminsuredListHeaderDetails';

function AssetList({
  rfqId,
  sectionId,
  sumInsuredData,
  showDataList = false,
  rfqDetails = null,
  placementSlip = false,
  type = null, policyDetail = null, qcRemarkOfEachSections = null, checkAllModuleIsVerified = null,
  setQcRemarkOfEachSections = null,
  EndorsementCompareQcRemarks = null
}) {
  const [assetGroups, setAssetGroups] = useState([]);
  useEffect(() => {
    fetchEmpGroups();
  }, []);

  const fetchEmpGroups = () => {
    request({
      url: 'rfqOffers/getRFQListGroupsForOffers',
      method: 'post',
      data: {
        rfqId: rfqId,
        rfqSectionId: sectionId
      }
    }).then(
      (response: any) => {
        setAssetGroups(response.data);
        if (response.data.length > 0) {
          let sumInsuredBox = document.getElementById('sumInsuredBox');
          if (sumInsuredBox) {
            sumInsuredBox.style.display = 'block';
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };
  const showSectionDataList = useSelector(selectDataListSectionIds);
  return (
    <>
      {assetGroups.length > 0 &&
        !sumInsuredData?.summaryViewStructure &&
        (showDataList ? showSectionDataList.includes(sectionId) : true) && (
          <Typography
            gutterBottom
            variant="h5"
            className="heading sumHead"
            component="div"
            style={{
              marginTop: '10px',
              marginBlock: '5px',
              fontWeight: 'bold!important',
              padding: '6px',
              background: 'rgb(9, 84, 174)',
              color: '#fff',
              textAlign: 'center'
            }}
          >
            {sumInsuredData?.sectionName}
          </Typography>
        )}

      {/* Show AssetListItem only if showDataList is true */}
      {showDataList &&
        showSectionDataList.includes(sectionId) &&
        assetGroups.length > 0 &&
        assetGroups.map((group) => (
          <AssetListItem
            key={group.id}
            sumInsuredData={sumInsuredData}
            groupDetails={group}
            rfqId={rfqId}
            type={type}
            policyDetail={policyDetail}
            qcRemarkOfEachSections={qcRemarkOfEachSections}
            checkAllModuleIsVerified={checkAllModuleIsVerified}
            setQcRemarkOfEachSections={setQcRemarkOfEachSections}
            EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
          />
        ))}

      {/* If showDataList is false, decide based on sumInsuredData?.summaryViewStructure */}
      {!showDataList && (
        <>
          {' '}
          {sumInsuredData?.summaryViewStructure ? (
            <SummaryViewBox
              isFromView={true}
              sectionId={sectionId}
              time=""
              closeForm={() => { }}
              reGenerate={() => { }}
              summaryViewData={sumInsuredData?.summaryViewStructure?.summary}
              summaryStructureData={sumInsuredData?.summaryViewStructure}
            />
          ) : (
            assetGroups.length > 0 &&
            assetGroups.map((group) => (
              <AssetListItem
                key={group.id}
                sumInsuredData={sumInsuredData}
                groupDetails={group}
                rfqId={rfqId}
                type={type}
                policyDetail={policyDetail}
                qcRemarkOfEachSections={qcRemarkOfEachSections}
                checkAllModuleIsVerified={checkAllModuleIsVerified}
                setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
              />
            ))
          )}
          {rfqDetails &&
            (rfqDetails['clauseAndCovPosition'] == 'Below-SI' ||
              rfqDetails['clauseAndCovPosition'] == 'Cov-below-SI') &&
            !placementSlip && (
              <ClauseAndCoverageAfterSI
                rfqDetails={rfqDetails}
                rfqId={rfqId}
                sectionId={sectionId}
              />
            )}
          {sumInsuredData?.totalSumInsured && <SuminsuredListHeaderDetails sumInsuredData={sumInsuredData} />}
        </>
      )}
    </>
  );
}

export default AssetList;
